import { Component, OnInit } from '@angular/core';
import { EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DatePipe } from '@angular/common'
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import { Filter } from 'src/app/core/models/search.types';



@Component({
    selector: '[filter-control]',
    templateUrl: './filter-control.component.html',
    styleUrls: ['./filter-control.component.scss'],
    standalone: false
})
export class FilterControlComponent implements OnInit {
  // scroll options
  options = {
    autoHide: false,
  };

  @Input() filterFields: Filter[] = [];
  @Input() enableOnlyDateRange: boolean = false

  @Output() updatedFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() transactionsChartDateRange: EventEmitter<any> = new EventEmitter<any>();
  @Output() collapsed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterCount: EventEmitter<number> = new EventEmitter<number>();

  filtersForm: FormGroup;
  formInitialize: boolean = false;
  @Input() action: any;

  basicMessages = {
    emptyMessage: "",
  };


  rangeValue: { from: Date; to: Date } = {
    from: null,
    to: null,
  };

  plugins = [confirmDatePlugin({ confirmIcon: '' })]

  constructor(public _formBuilder: FormBuilder, public _datePipe: DatePipe, public _translate: TranslateService,) {
    this.filtersForm = this._formBuilder.group({});
    this._translate.get("COMMON.NO_DATA").subscribe((res) => {
      this.basicMessages.emptyMessage = res;
    });
  }

  ngOnInit() {
    // build filterFields
    // console.log(this.filterFields);

    if (this.filterFields) {
      let form = {};
      this.filterFields.forEach((element: any) => {
        let inputValue;
        if (element.dataType === "SELECT") {
          inputValue = element?.filteredValues ? element?.filteredValues[0] : null
        } else {
          inputValue = element?.filteredValues ? element?.filteredValues : null
        }
        Object.assign(form, {
          [element.fieldName]: [inputValue]
        });
      });
      form = { ...form };
      this.filtersForm = this._formBuilder.group({ ...form });
      // console.log(this.filtersForm);

      this.formInitialize = true
    }
  }

  /**
   * Update Filters Function
   * @param name
   * @param value
   */
  updateFilters(name: any, value: any) {
    const filters = this.filterFields.map((element: any) => {
      let tempVal = { ...value };
      if (element.fieldName === name) {
        if ((element.dataType === "SELECT" && (value === null || value === undefined))
          || (element.dataType === "BOOLEAN" && !value) || (element.dataType === "MULTI_SELECT" && value === null)) {
          delete element?.filteredValues;
          return element;
        } else if (element.dataType === "BOOLEAN" && value) {
          return {
            ...element,
            filteredValues: [`${value}`]
          };
        } else if (element.dataType === "DATE_TIME") {
          return {
            ...element,
            filteredValues: [value],
          };
        } else if (element.dataType === "DATE") {
          return {
            ...element,
            filteredValues: [value],
          };
        } else if (element.dataType === "MULTI_SELECT") {
          return {
            ...element,
            filteredValues: value,
          };
        } else if (element.dataType === "SELECT" && !element.enumValues) {
          return {
            ...element,
            filteredValues: [tempVal]
          };
        }
        else return {
          ...element,
          filteredValues: value ? [value] : []
        };
      } else return element;
    });
    this.filterFields = filters;
  }

  /**
   * On Radio Box Change Function
   * @param item
   * @param fieldName
   */
  onRadioboxChange(item: any, fieldName: any) {
    //this.updateFilters(element.fieldName, x);
    this.updateFilters(fieldName, item);
  }

  /**
  * On Check Box Changed Function
  * @param item
  * @param fieldName
  * @param $event
  */
  onCheckboxChanged(item: any, fieldName: any, $event: any) {
    item.checked = $event.target.checked;
    // this.filtersForm.get(fieldName).setValue($event.target.checked);
    this.updateFilters(fieldName, item);
  }

  /**
* On Select Changed Function
* @param item
* @param fieldName
*/
  onSelectChanged(item: any, fieldName: any) {
    // this.updateFilters(fieldName, item);
    // console.log(this.filtersForm);
    this.updateFilters(fieldName, item);
  }

  /**
  * Array Remove Function
  * @param arr
  * @param value
  */
  arrayRemove(arr: any, value: any) {
    return arr.filter(function (ele: any) {
      return ele.id ? ele.id != value.id : ele.value != value.value;
    });
  }

  /**
  * Check Multi Select Equality Function
  * @param item1
  * @param item2
  */
  checkMultiSelectEquality(item1: any, item2: any) {
    return item1.id ? item1.id === item2.id : item2.value === item1.value;
  }

  /**
  * Clear Filters Function
  */
  clearFilters() {
    this.filtersForm.reset();
    const filters = this.filterFields.map((element: any) => {
      delete element?.filteredValues;
      return element;
    });
  }

  /**
  * Check In Filtered Values Function
  * @param item
  * @param filteredValues
  */
  checkInFilteredValues(item: any, filteredValues: any) {
    if (filteredValues) {
      filteredValues.forEach((choice: any) => {
        if (this.checkMultiSelectEquality(choice, item)) {
          return item.value
        } else {
          return ''
        }
      });
    }
    return ''
  }

  /**
  * Reset Filters Function
  */
  resetFilters() {
    this.filtersForm.reset();
    const filters = this.filterFields.map((element: any) => {
      delete element?.filteredValues;
      return element;
    });
    this.updatedFilters.emit(filters);
    this.transactionsChartDateRange.emit(this.rangeValue);
  }

  /**
  * Change Collapsed Function
  */
  changeCollapsed() {
    this.collapsed.emit(false);
  }

  /**
  * Change Max Viewed Elements Function
  */
  changeMaxViewedElements(item: any) {
    item.maxViewedOptionsCount += (item.selectValues.length - item.maxViewedOptionsCount) > 5 ? 5 : (item.selectValues.length - item.maxViewedOptionsCount);
  }

  /**
  * Show All Options Function
  * @param item
  */
  showAllOptions(item: any) {
    item.maxViewedOptionsCount = (item.selectValues.length);
  }

  /**
  * View See More Function
  * @param item
  */
  viewSeeMore(item: any) {
    return (item.selectValues.length - item.maxViewedOptionsCount) <= 0 ? false : true;
  }

  /**
  * Update Date Control Function
  * @param fieldName
  */
  updateDateFilterControl(type: string, value: any, fieldName: any) {
    // console.log(this.filtersForm.get(fieldName).value);
    // console.log(type);
    if (type === ('DATE_TIME')) {
      value = value + 'T00:00'
    }
    if (fieldName === ('transactionFrom')) {
      this.rangeValue.from = this.filtersForm.get(fieldName).value

    }
    if (fieldName === ('transactionTo')) {
      this.rangeValue.to = this.filtersForm.get(fieldName).value

    }
    this.updateFilters(fieldName, value);
  }


  /**
* Update Date Control Function
* @param fieldName
*/
  updateFilterControl(fieldName: any) {
    this.updateFilters(fieldName, this.filtersForm.get(fieldName).value);
  }
  /**
  * Submit Filter Function
  */
  submitFilter() {
    this.updatedFilters.emit(this.filterFields);
    this.transactionsChartDateRange.emit(this.rangeValue);
  }
}
